import React from "react";
import $ from "./services.module.scss";

export const Services = () => {
  const cards = [
    {
      class: `${$.service_card} + ${$.card_1}`,
      title: "Custom \nWeb Development ",
      desc: "We offer custom website and software development, delivering tailored, scalable solutions for seamless user experiences. Whether you need a custom website or bespoke software, we create high-performance solutions that drive growth.",
    },
    {
      class: `${$.service_card} + ${$.card_2}`,
      title: "Web Design",
      desc: "We specialize in creating minimalist and functional designs, tailor-made to meet your specific business strategy. Our designs adapt seamlessly across various devices, ensuring a consistent and engaging user experience.",
    },
    {
      class: `${$.service_card} + ${$.card_3}`,
      title: "AI Development",
      desc: "We specialize in custom AI development, crafting intelligent solutions. From personalized chatbots and AI-powered search to local RAG (retrieval-augmented generation) solutions, our technology enhances user experiences and drives efficiency. We focus on seamless integration, ensuring smooth performance across all platforms and devices.",
    },
    {
      class: `${$.service_card} + ${$.card_4}`,
      title: "Web Hosting",
      desc: "Our experience in full-stack web development, coupled with our expertise in cloud computing platforms, guarantees a reliable and scalable web infrastructure tailored to your business needs.",
    },
  ];
  return (
    <section id="services_section">
      <div className={$.service_container}>
        <div className={$.service_container_header}>
          <h1>Our Services Include</h1>
        </div>
        <div className={$.service_container_card_wrapper}>
          {cards.map((item, index) => (
            <div className={item.class} key={index}>
              <div className={$.card_header}>
                <h2><b>{item.title}</b></h2>
              </div>
              <div>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
